import { buildLeadDetailsPath } from "../my-mls/leadDetailsNavigation"

export function inboxContactDisplayName(contact) {
  if (!contact) {
    return null
  }
  return (
    contact.candidate_name ||
    contact.contact_name ||
    contact.candidate_email ||
    contact.counterparty_phone ||
    contact.from_phone ||
    null
  )
}

export function inboxContactDetailsPath(thread) {
  if (thread?.candidate_id) {
    return `/candidates/${thread.candidate_id}`
  }
  const source = thread?.contact_source
  const id = thread?.contact_id
  if ((source === "mls" || source === "uploaded") && id) {
    return buildLeadDetailsPath(source, id)
  }
  return null
}
